export interface IDocumentTemplateListItem {
    id: string;
    code: string;
    comment: string;
    landscapeOrientation: boolean;
    companyId: string;
}

export class DocumentTemplateListItem implements IDocumentTemplateListItem {
    id: string;
    code: string;
    comment: string;
    landscapeOrientation: boolean;
    companyId: string;

    constructor();
    constructor(obj: IDocumentTemplateListItem);
    constructor(obj?: any) {
        this.id = obj?.id || "";
        this.code = obj?.code || "";
        this.comment = obj?.comment || "";
        this.landscapeOrientation = obj?.landscapeOrientation || false;
        this.companyId = obj?.companyId || "";
    }
}
